import { RouteMetadata } from './types';

export const promptsMetadata: RouteMetadata[] = [
    {
        pattern: '/agents/:agentId/prompts/:promptId/file/:fileId',
        section: 'prompts',
        view: 'file-editor',
        descriptionTemplate: 'User is editing file {fileId} within prompt {promptId}',
        capabilities: [
            'Edit the prompt file content',
            'Use variables with {{variable}} syntax',
            'Import content from other prompts',
            'Preview how the prompt renders',
            'Save changes to the file',
        ],
        hints: [
            'This file is part of a multi-file prompt',
            'Prompts can include system instructions, examples, and templates',
            'Variables are replaced at runtime with actual values',
            'Files can be markdown, text, or other formats',
        ],
    },
    {
        pattern: '/agents/:agentId/prompts/:promptId',
        section: 'prompts',
        view: 'editor',
        descriptionTemplate: 'User is editing prompt {promptId}',
        capabilities: [
            'View and manage prompt files',
            'Create new files within the prompt',
            'Delete files from the prompt',
            'Configure prompt metadata',
            'Test the prompt',
        ],
        hints: [
            'Prompts are collections of text files',
            'Each prompt can have multiple files',
            'Files are combined when the prompt is used',
            'Prompts can be used in workflows and agents',
        ],
    },
    {
        pattern: '/agents/:agentId/prompts',
        section: 'prompts',
        view: 'list',
        descriptionTemplate: 'User is viewing the prompts list',
        capabilities: [
            'View all prompts',
            'Create new prompts',
            'Import prompts',
            'Delete prompts',
            'Search and filter prompts',
        ],
        hints: [
            'Prompts are reusable text templates',
            'Prompts can contain variables and instructions',
            'Prompts are used to guide LLM behavior',
        ],
    },
];
